import React, {Component} from 'react';

import './Page.css';

class Page extends Component {
	render() {
		return <main className={`Page ${this.props.className || ''}`}>{this.props.children}</main>;
	}
}

export default Page;



// WEBPACK FOOTER //
// ./src/widgets/Page.js